import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { MarketplacePaymentClient } from 'src/WebApiController';

export const GET_PAYMENT_LINES_WITH_SALES_QUERY_KEY =
  'MarketplacePaymentClient.getPaymentLinesWithSales';

export const useGetMarketplacePaymentLinesWithSales = (
  marketplacePaymentId: number,
  disabled: boolean
) => {
  const { activeAccountWebClientConfig } = useAppContext();

  const { trackError } = useClientLogContext();

  const shouldQuery =
    !disabled &&
    activeAccountWebClientConfig.activeAccountId != null &&
    !!marketplacePaymentId;

  const paymentLineQuery = useQuery({
    queryKey: [
      GET_PAYMENT_LINES_WITH_SALES_QUERY_KEY,
      activeAccountWebClientConfig.activeAccountId,
      marketplacePaymentId,
    ],
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }
      return await new MarketplacePaymentClient(
        activeAccountWebClientConfig
      ).getPaymentLinesWithSales(marketplacePaymentId);
    },

    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('MarketplacePaymentClient.getPaymentLinesWithSales', error, {
          marketplacePaymentId,
        });
      },
    },
    enabled: shouldQuery,
  });

  return { paymentLineQuery };
};
